export type OnlineMultiBuyDiscountTier = {
  minimumQuantity: number;
  percentOff: number;
  label: string;
  couponId: string;
};

/** Paused while the 3-for-2 online offer is live. Re-enable to restore % tiers. */
export const ONLINE_MULTI_BUY_ENABLED = false;

export const ONLINE_MULTI_BUY_TIERS: OnlineMultiBuyDiscountTier[] = [
  {
    minimumQuantity: 4,
    percentOff: 15,
    label: "15% off 4+ online courses",
    couponId: "online-multi-buy-15",
  },
  {
    minimumQuantity: 2,
    percentOff: 10,
    label: "10% off 2+ online courses",
    couponId: "online-multi-buy-10",
  },
];

export const getOnlineMultiBuyDiscountTier = (quantity: number) => {
  if (!ONLINE_MULTI_BUY_ENABLED) {
    return null;
  }

  return (
    ONLINE_MULTI_BUY_TIERS.find((tier) => quantity >= tier.minimumQuantity) ||
    null
  );
};

export const calculateOnlineMultiBuyDiscount = (
  quantity: number,
  subtotalPence: number,
) => {
  const tier = getOnlineMultiBuyDiscountTier(quantity);

  if (!tier || subtotalPence <= 0) {
    return {
      tier,
      discountPence: 0,
      finalTotalPence: Math.max(subtotalPence, 0),
    };
  }

  const discountPence = Math.round((subtotalPence * tier.percentOff) / 100);

  return {
    tier,
    discountPence,
    finalTotalPence: Math.max(subtotalPence - discountPence, 0),
  };
};
